export const groupRequestVisibilityTypes = [
  {
    key: 'public',
    title: 'Public',
  },
  {
    key: 'members-only',
    title: 'Members-Only',
  },
  {
    key: 'hidden',
    title: 'Hidden',
  },
].map(x => ({ ...x, id: x.key }))
